

// Get filtered restaurants

function printToppingPortion(thePortion) {
    if (thePortion == "H1") {
        return " (first half only), ";
    }
    else if (thePortion == "H2") {
        return " (second half only), ";
    }
    else {
        return  ", ";
    }
}

export default (specialItem, special) => {
    let itemDetails = "";

    // find the special item choice that we're dealing with
    if (special.items) {
        special.items.forEach((theItem) => {
            theItem.choices.forEach((theItemChoice) => {
                if (theItemChoice.id == specialItem.choice_id) {

                    // we found our match. Now let's determine what type it is
                    if (theItemChoice.pizza_id) {

                        // add the topping details
                        specialItem.toppings.forEach((theCartTopping) => {
                            theItemChoice.toppings.forEach((theTopping) => {
                                if (theTopping.id == theCartTopping.id) {
                    
                                    if (theCartTopping.isdefault && theCartTopping.amount == "extra") {
                                        itemDetails += "Extra "+theTopping.name+printToppingPortion(theCartTopping.portion);
                                    }
                                    else if (theCartTopping.isdefault && theCartTopping.amount == "none") {
                                        itemDetails += "No "+theTopping.name+printToppingPortion(theCartTopping.portion);
                                    }
                                    else if (theCartTopping.isdefault && theCartTopping.portion != "W") {
                                        itemDetails += "Include "+theTopping.name+printToppingPortion(theCartTopping.portion);
                                    }
                                    else if (theCartTopping.isdefault) {
                                        itemDetails += theTopping.name+printToppingPortion(theCartTopping.portion);
                                    }
                                    else if (!theCartTopping.isdefault && theCartTopping.amount == "include") {
                                        itemDetails += "Add "+theTopping.name+printToppingPortion(theCartTopping.portion);   
                                    }
                                }
                            });
                        });

                        // add the crust details
                        if (specialItem.crust_id != 0) {
                            theItemChoice.crusts.forEach((theSpecialCrust) => {
                                if (theSpecialCrust.id == specialItem.crust_id) {
                                    if (parseFloat(theSpecialCrust.price) > 0) {
                                        itemDetails += theSpecialCrust.name + " - " + theSpecialCrust.price + ", ";
                                    }
                                    else {
                                        itemDetails += theSpecialCrust.name + ", ";
                                    }
                                }
                            });
                        }

                        // add the sauce details
                        if (specialItem.sauce_id != 0) {
                            theItemChoice.sauces.forEach((theSpecialSauce) => {
                                if (theSpecialSauce.id == specialItem.sauce_id) {
                                    if (parseFloat(theSpecialSauce.price) > 0) {
                                        itemDetails += theSpecialSauce.name + " - " + theSpecialSauce.price + ", ";
                                    }
                                    else {
                                        itemDetails += theSpecialSauce.name + ", ";
                                    }
                                }
                            });
                        }

                    
                    }
                    else if (theItemChoice.custom_pizza_id) {
                        
                        // print the toppings
                        specialItem.toppings.forEach((theCartTopping) => {
                            theItemChoice.toppings.forEach((theTopping) => {
                                if (theTopping.id == theCartTopping.id) {
                                    itemDetails += theTopping.name+printToppingPortion(theCartTopping.portion);
                                }
                            });
                        });

                        // print the crust
                        if (specialItem.crust_id != 0) {
                            theItemChoice.crusts.forEach((theSpecialCrust) => {
                                if (theSpecialCrust.id == specialItem.crust_id) {
                                    if (parseFloat(theSpecialCrust.price) > 0) {
                                        itemDetails += theSpecialCrust.name + " - " + theSpecialCrust.price + ", ";
                                    }
                                    else {
                                        itemDetails += theSpecialCrust.name + ", ";
                                    }
                                }
                            });
                        }

                        // print the sauce
                        if (specialItem.sauce_id != 0) {
                            theItemChoice.sauces.forEach((theSpecialSauce) => {
                                if (theSpecialSauce.id == specialItem.sauce_id) {
                                    if (parseFloat(theSpecialSauce.price) > 0) {
                                        itemDetails += theSpecialSauce.name + " - " + theSpecialSauce.price + ", ";
                                    }
                                    else {
                                        itemDetails += theSpecialSauce.name + ", ";
                                    }
                                }
                            });
                        }
                    }
                    else if (theItemChoice.food_item_id) {
                        
                        // add the choice details
                        specialItem.choices.forEach((theChoice) => {
                            if (theChoice.is_multiple) {
                                if (theChoice.items.length > 0) {
                                    itemDetails += theChoice.item_name + ", ";
                                }
                            }
                            else {
                                itemDetails += theChoice.item_name;

                                if (parseFloat(theChoice.item_price) > 0) {
                                    itemDetails += " - " + theChoice.item_price;
                                }
                                itemDetails += ", ";
                            }
                        });

                        // add any applicable addon details
                        specialItem.addons.forEach((theCartAddon) => {
                            theItemChoice.fooditem.addons.forEach((theAddon) => {
                                if (theAddon.id == theCartAddon) {
                                    itemDetails += theAddon.name;

                                    if (parseFloat(theAddon.price) > 0) {
                                        itemDetails += " - " + theAddon.price;
                                    }
                                    itemDetails += ", ";
                                }
                            });
                        });

                    }
                    else if (theItemChoice.beverage_id) {
                        itemDetails = "";
                    }
                }
            });
        });
    }

    itemDetails = itemDetails.replace(/,\s*$/, "");
    return itemDetails;
};